import { LoadState } from "../../constants/enums";

export interface ICategoryState {
  list: ICategory[];
  loading: LoadState;
  totalRecords: number;
}

export interface ICategory {
  category_uuid: string | null;
  category_name: string | null;
  food_type: string | null;
  status: string;
}

export const initialCategoryState: ICategoryState = {
  list: [],
  loading: LoadState.NotLoaded,
  totalRecords: 0,
};

export const initialCategory: ICategory = {
  category_uuid: null,
  category_name: null,
  food_type: null,
  status: "ACTIVE",
};
